import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const GbSctIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <path fill="#0065bd" d="M0 0h640v480H0z" />
    <path
      stroke="#fff"
      strokeWidth={0.6}
      d="m0 0 5 3M0 3l5-3"
      transform="scale(128 160)"
    />
  </ChakraIcon>
);
